export default __webpack_public_path__ + "static/us-consumer-reviews-teaser-3bbf86a587651bebec325e84574b58d9.jpeg";